import Pqp from "./Pqp.js";
import Parser from "./Parser.js";

export default class Locale {
  static init(data, locale) {
    //console.log("Locale.init", data, locale);
    Locale.LABELS = [];
    Locale.currentLocale = locale;
    /*for (const key in data) {
      Locale.LABELS[key] = data[key];
    }*/
    for (let i = 0; i < data.length; i++) {
      Locale.LABELS[data[i].id] = data[i]["" + locale] || "";
    }
  }

  static g(key, def = null, ...args) {
    key = "Player." + key;
    if (Locale.LABELS === null) {
      console.log("Locale.LABELS is null");
      return def;
    }
    if (Pqp.isNullOrEmpty(Locale.LABELS[key])) {
      if (Pqp.isNullOrEmpty(def)) {
        return "[" + key + "]";
      }
      console.log("Default value for " + key + ": " + def);
      return Parser.parse(Locale.applyParams(def, args));
    }
    if (Locale.debugShowLabelsUsed) {
      return "*" + Locale.applyParams(Locale.LABELS[key], args) + "*";
    }

    return Parser.parse(Pqp.safeReplace(Locale.applyParams(Locale.LABELS[key], args), "\n", "<br />"));
  }

  static applyParams(str, args) {
    if (args.length === 0) {
      return str;
    }
    for (let i = 0; i < args.length; i++) {
      str = Pqp.safeReplace(str, "{{" + i + "}}", args[i]);
    }
    return str;
  }

  static ga(key) {
    if (Locale.LABELS === null) {
      console.log("Locale.LABELS is null");
      return key;
    }
    if (Pqp.isNullOrEmpty(Locale.LABELS[key])) {
      return "[" + key + "]";
    }
    const a = Locale.LABELS[key].split("|");
    for (let i = 0; i < a.length; i++) {
      a[i] = Pqp.safeReplace(a[i].trim(), "\\n", "\n");
      if (Locale.debugShowLabelsUsed) {
        a[i] = "*" + a[i] + "*";
      }
    }
    return a;
  }
}

Locale.LABELS = null;
Locale.currentLocale = null;

// Enable this to debug labels by showing them with asterisks
Locale.debugShowLabelsUsed = false;
